import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import TestCaseSetList from './TestCaseSetList';

import { fetchProjectCollections } from '../../redux-store/currentUserActions';

const TestScenarioBody = ({ project, testScenarioId, isAiAgent = false, createTestScenarioRequestAIAgent, expandTestCaseIdOnLoad = null }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    getCollections();
  }, []);

  const getCollections = async () => {
    await dispatch(fetchProjectCollections(project.id));
  }

  const getNewTestCase = () => {
    return {
      id: Date.now().toString(),
      isNew: true,
      title: "Step title",
      collection: null,
      entity: null,
    }
  }

  return (
    <Box>
      <TestCaseSetList testScenarioId={testScenarioId} getNewTestCase={getNewTestCase} project={project} isAiAgent={isAiAgent} createTestScenarioRequestAIAgent={createTestScenarioRequestAIAgent}  expandTestCaseIdOnLoad={expandTestCaseIdOnLoad} />
    </Box>
  )
}

export default TestScenarioBody
